export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/08ee3b32e72dd5b2b700754671ea2016.svg";